import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';

export const AdminLogin: React.FC = () => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = await login('manager', pin);
      if (success) {
        navigate('/admin/dashboard');
      } else {
        setError('קוד גישה שגוי');
      }
    } catch (err) {
      setError('שגיאה בהתחברות');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="card">
          <h1 className="text-2xl font-bold text-center mb-6">כניסת מנהל</h1>

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label className="block text-sm font-medium mb-2">
                קוד גישה (4 ספרות)
              </label>
              <input
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                placeholder="••••"
                maxLength={4}
                className="input-field text-center text-2xl tracking-widest"
                autoFocus
              />
            </div>

            {error && (
              <div className="mb-4 p-3 bg-red-500/20 border border-red-500 rounded text-red-400 text-center">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={pin.length !== 4 || loading}
              className="btn-primary w-full"
            >
              {loading ? 'מתחבר...' : 'כניסה'}
            </button>
          </form>

          <button
            onClick={() => navigate('/')}
            className="btn-secondary w-full mt-4"
          >
            חזרה
          </button>
        </div>
      </div>
    </div>
  );
};
export default AdminLogin;
